// @ts-nocheck
import { TrackJS } from "trackjs";
import ls from "@/services/local-storage";
import { useAuthStore } from "@/stores/auth.store";
import router from "@/router";
interface AuthHeader {
  Authorization: string;
}
interface AuthError {
  headers: AuthHeader;
  config?: {
    headers: AuthHeader;
  };
  response?: {
    headers: AuthHeader;
    config: {
      headers: AuthHeader;
    };
  };
}
const removeAuthorizationHeader = (headers: AuthHeader): void => {
  if (headers.hasOwnProperty("Authorization")) {
    delete headers.Authorization;
  }
};

const getErrorInfo = (error: AuthError): AuthError => {
  const errorCopy = { ...error };
  if (
    errorCopy.config &&
    errorCopy.config.headers.hasOwnProperty("Authorization")
  ) {
    removeAuthorizationHeader(errorCopy.config.headers);
  }
  if (errorCopy.response) {
    removeAuthorizationHeader(errorCopy.response.headers);
    removeAuthorizationHeader(errorCopy.response.config.headers);
    return errorCopy.response;
  }
  return errorCopy.config ? errorCopy.config : errorCopy;
};

export default (error: AuthError): Promise<AuthError> => {
  if (
    error.response?.status === 401 &&
    router.currentRoute.value.name !== "login"
  ) {
    ls.clearToken();
    useAuthStore().clearLoggedIn();
    router.replace({ name: "login", query: { session_expired: "true" } });
  }
  const errorInfo = getErrorInfo(error);
  TrackJS.console.log(errorInfo);
  return Promise.reject(error);
};
